import axios from 'axios';
import React, { useState } from 'react'
import styled from 'styled-components';
import { API_URL } from '../../const/api';
import { PRIMARY } from '../../const/colors';
import { mobile_normal } from '../../const/fonts';
import ErrorContainer from './ErrorContainer';
import CheckIcon from '@mui/icons-material/Check';
import InfoIcon from '@mui/icons-material/Info';
import { useTranslation } from "react-i18next";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
const Container = styled.div`
	position: relative;
  flex:1;
	width: 100%;
  margin: 0.5rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .containerinput{
    position: relative;
    width: 100%;
  }

	>.containerinput input {
		border: 1px solid ${PRIMARY};
		outline: none;
		background-color: transparent;
		color: #888;
		padding: 0.7rem 1rem;
		font-size: 1rem;
		width: 100%;
    transition: all 0.3s ease;
    text-align: justify;
	}

  input {
    color:  #fff;
  }
  
	 label {
    font-size: 1rem;
		padding: 0 1rem;
    font-weight: bold;
		color: #fff;
	}

  input.hide {
    opacity: 0;
    visibility: hidden;
  }
  input.show {
    opacity: 1;
    visibility: show;
  }
  input[type="date"]::-webkit-calendar-picker-indicator {
    filter: invert(1);
  }
	&:hover {
		input, select {
			border-color: #fff;
		}
	}

  &.small {
    width: 50px !important;
    flex: 0.5;
  }

  @media screen and (max-width: 2000px) {
	  width: 100%;
    &.small {
    width: 50px !important;
  }
    input, label, select, .MuiFormControlLabel-label {
      font-size: 0.8rem;
      margin: 0.2rem 0;
    }

  }
  @media screen and (max-width: 1600px) {
    margin: 0.25rem 1rem;
  }
  @media screen and (max-width: 768px) {
    align-items: center;
    input, label, select {
      font-size: ${mobile_normal};
    }
    margin: 0.8rem auto;
    text-align: center;

    >.containerinput input {
      color:white;
      text-align:justify;
      font-weight: bold;
      font-size:14px;
    }
  }

  >.containerinput input.error,.containerinput select.error {
    border-color: #C21010;
  }
  >.containerinput input.correct,.containerinput select.correct {
    border-color: #28a745;
  }
`;

const Check = styled(CheckIcon)`
  color: #28a745;
  position: absolute;
  right: 0.5rem;
  top: 12px;
`;

const WarningPass = styled.div`
  display:inline-flex;
  align-items: center;
  font-size: 10px;
  color: #fff;
  margin-left: 5px;
  svg {
    font-size: 1rem;
    color: #C21010;
    margin-right: 5px;
  }
`

const InputBox = ({val, placeholder, label, handleChange, handleBlur, name, error, type,consultInput}) => {
  const [focused, setFocused] = useState(false);
  const [serverError, setServerError] = useState('');
  const [t, i18n] = useTranslation("global");
  const [password, setPassword] = useState(val);
  const [strength, setStrength] = useState("");
  const [strengthColor, setStrengthColor] = useState('black');
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);

  function evaluatePasswordStrength(password) {
    let score = 0;

    if (!password) return '';

    // Check password length
    if (password.length > 2) score += 1;
    if (password.length > 4) score += 1;
    if (password.length > 7) score += 1;
    // Contains lowercase
    // if (/[a-z]/.test(password)) score += 1;
    // Contains uppercase
    // if (/[A-Z]/.test(password)) score += 1;
    // Contains numbers
    // if (/\d/.test(password)) score += 1;
    // Contains special characters
    // if (/[^A-Za-z0-9]/.test(password)) score += 1;

    switch (score) {
      case 1:
        setStrengthColor('red');
        return t("sign-in.passDebil");
      case 2:
        setStrengthColor('orange');
        return t("sign-in.passMedio");
      case 3:
        setStrengthColor('green');
        return t("sign-in.passfuerte");
      default:
        return '';
    }
  }

  const handleChangePass = (event) => {
    const { value } = event.target;
    setPassword(value);
    setStrength(evaluatePasswordStrength(value));
  };

  const handleChangeWrapper = (e) => {
    const { name, value } = e.target;
    const valueToSend = name === 'email' ? value.toLowerCase() : value; // Convertir a minúsculas si el campo es el email
    handleChange({ target: { name, value: valueToSend } });
  };

  const handleToggleCurrentPasswordVisibility = () => {
    setShowCurrentPassword((prevShowCurrentPassword) => !prevShowCurrentPassword);
  };

  const handleFocus = async (e) => {
    handleBlur(e);
    setFocused(true);
    const { value } = e.target;

    if(name==='fecha_nac') return;
    if(name==='address') return;
    if(name==='letraONumero') return;

    if(name === "nombre"){
      const valueName = value.trim();
      if(value !== valueName){
        setServerError("No se permiten espacios en blanco al inicio o al final.")
      }else{
        setServerError(null);
      }
      return;
    }
    if(name === "usuario"){
      const resUsuario = await axios.post(API_URL+'validarFormulario', {usuario: value});
      if(resUsuario.data.response.error===1){
        setServerError(resUsuario.data.response.tipo)
        return;
      }
      const valueName = value.trim();
      if(value !== valueName){
        setServerError("No se permiten espacios en blanco al inicio o al final.")
        return;
      }else{
        setServerError(null);
      }
    }
    const res = await axios.post(API_URL+'validarFormulario', {[name]: val});
    if(res.data.response.error===1) {
        setServerError(res.data.response.tipo);
        } else {
        setServerError(null);
      }
  };

  return (
    <Container className={name==='letraONumero' ? 'small' : ''}>
      <label>{label}</label>
      <div className='containerinput'>
        {type == "password" ? 
          <>
            <input 
              id='mypass'
              type={showCurrentPassword ? "text" : "password"}
              placeholder={placeholder} 
              value={password} 
              onChange={handleChangePass}
              onBlur={handleFocus}
              name={name}
              required={true} 
              minLength={8}
              className={(error || serverError || password.length < 8) ? 'error' : (error && serverError && password.length >= 8) ? 'correct' : null}
            />
            {
              <>
                <div style={{position:'absolute',top:'13px',right:'35px'}}>{' '}<span
                  style={{
                    fontWeight: 'bold',
                    color: strengthColor,
                  }}>{strength}
                  </span>
                </div>
                {((!error && !serverError) && password.length < 8) && <WarningPass>
                      <InfoIcon/>{t("sign-in.passwordconfirm")}
                  </WarningPass>
                }
                <span
                  style={{
                    position: "absolute",
                    top: "25px",
                    transform: "translateY(-50%)",
                    right: "1%",
                    color:"#ffce05",
                    cursor:"pointer"
                  }}
                  onClick={handleToggleCurrentPasswordVisibility}
                >
                  {showCurrentPassword ? (
                    <VisibilityOffIcon />
                  ) : (
                    <VisibilityIcon />
                  )}
                </span>
              </>
            }
            {
              (focused && (error || serverError)) && <ErrorContainer focused={focused.toString()} error={error || serverError} />
            }
          </>
          :
          <>
            <input 
              type={type} 
              placeholder={placeholder} 
              value={val} 
              onChange={handleChangeWrapper} // Usar la función de cambio envuelta
              onBlur={handleFocus}
              name={name}
              className={((error||serverError) && focused) ? 'error' : ((!error||!serverError) && focused) ? 'correct' : null}
              maxLength={name==='letraONumero' ? 3 : 100}
            />
            {
              (focused && (error || serverError)) && <ErrorContainer focused={focused.toString()} error={error || serverError} />
            }
            {
              (!(error||serverError) && focused) && <Check />
            }
          </>
          }
      </div>
    </Container>
  )
}

export default InputBox;